import { useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../contexts/TranslationContext';
import routes from '../../../shared/constants/routes';
import StepperProgressVertical from '../RequestsFullCardsView/StepperProgress/StepperProgressVertical';
import './requestsCardsNew.css';

export default function RequestsCardsNew({ requests, onDelete, onEdit }) {
    const { translate } = useTranslation();
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);

    if (!requests || requests.length === 0) {
        return null;
    }

    const appIsV1 = (request) => {
        if (!request?.APPLID) return null;
        const applId = String(request.APPLID);
        return /^\d+$/.test(applId);
    };

    const uploadButtonAvailable = (request) => {
        if (
            request.OFFER_STATUS !== 'EXPIRED' &&
            request.IVR_STATUS !== 'ACCEPTED' &&
            request.IVR_STATUS !== 'REJECTED' &&
            request.OFFER_STATUS !== 'REJECTED' &&
            request.OFFER_STATUS !== 'ACCEPTED' &&
            request.CONTRACT_STATUS !== 'SIGNED' &&
            request.CONTRACT_STATUS !== 'REJECTED' &&
            (request.FINAL_STATUS !== 'REJECTED' && !request.FINAL_REJECTION_REASON)
        )
            return true;
        return false;
    };

    const viewOffer = (request) => {
        navigate(`/app/${routes.VIEW_OFFER}/${request?.APPLID}`);
    };

    const viewContract = (request) => {
        navigate(`/app/${routes.VIEW_CONTRACT}/${request?.APPLID}/${request.CONTRACT_STATUS}`);
    };

    const uploadDocument = (request) => {
        navigate(`/app/${routes.UPLOAD_ADDITIONAL_DOCUMENT}/${request?.APPLID}`);
    };

    const applicationStatus = (request) => {
        return (
            request.CONTRACT_STATUS ||
            request.OFFER_STATUS ||
            (request.APPLICATION_STATUS === 'S' && 'Submitted') ||
            (request.APPLICATION_STATUS === 'D' && 'DRAFT')
        );
    };

    const errorStatusClass = (request) => {
        if (
            request.OFFER_STATUS === 'REJECTED' ||
            request.CONTRACT_STATUS === 'REJECTED' ||
            request.QARAR_STATUS === 'REJECTED'
        )
            return 'rejected';
    };

    return (
        <div className="requests-new-wrapper">
            <div className="requests-new-list">
                {requests.map((request, idx) => {
                    const isActive = idx === activeIndex;

                    return (
                        <div
                            key={request.APPLID || idx}
                            className={`requests-new-list-row ${isActive ? 'expanded' : ''}`}
                        >
                            {!isActive &&
                                <button
                                    type="button"
                                    className={`requests-new-list-item ${isActive ? 'active' : ''}`}
                                    onClick={() => setActiveIndex(idx)}
                                >
                                    <span className="requests-new-list-id">
                                        {translate('HOME.DIGITAL_APP_ID')}: {request.APPLID || 'N/A'}
                                    </span>
                                    <span className="requests-new-list-toggle">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="6 9 12 15 18 9"></polyline>
                                        </svg>
                                    </span>
                                </button>
                            }

                            {isActive && (
                                <div className="requests-new-main-card">
                                    <div className="requests-new-header">
                                        <div>
                                            <h2 className="requests-new-title">{translate('HOME.REQUEST')}</h2>
                                            <p className="requests-new-subtitle">
                                                {translate('HOME.DIGITAL_APP_ID')}: {request.APPLID || 'N/A'}
                                            </p>
                                            {/* <p
                                                className={`requests-new-status ${errorStatusClass(request) || ''
                                                    }`}
                                            >
                                                {request.QARAR_STATUS === 'REJECTED'
                                                    ? 'Rejected'
                                                    : applicationStatus(request)}
                                            </p> */}
                                        </div>
                                        <div className="requests-new-actions">
                                            {request.APPLICATION_STATUS === 'D' && (
                                                <button
                                                    type="button"
                                                    className="requests-new-pill-button"
                                                    onClick={() => onEdit(request.APPLID)}
                                                >
                                                    {translate('OFFER_TABLE.EDIT')}
                                                </button>
                                            )}

                                            {request.APPLICATION_STATUS === 'D' && (
                                                <button
                                                    type="button"
                                                    className="requests-new-pill-button"
                                                    onClick={() => onDelete(request.APPLID)}
                                                >
                                                    {translate('DELETE')}
                                                </button>
                                            )}

                                            {uploadButtonAvailable(request) && (
                                                <button
                                                    type="button"
                                                    className="requests-new-pill-button primary"
                                                    onClick={() => uploadDocument(request)}
                                                >
                                                    {translate('HOME.UPLOAD_DOCUMENT')}
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    <div className="requests-new-stepper-wrapper">
                                        <StepperProgressVertical
                                            request={request}
                                            appIsV1={appIsV1(request)}
                                            onViewOffer={viewOffer}
                                            onViewContractSigning={viewContract}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
